import _noop from "lodash-es/noop";

/* eslint-disable no-console */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable no-lonely-if */
import React from 'react';
import styled from 'styled-components';
import { FormHelperText } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { ReactDateTimePicker } from '../../DatePicker';
import { defaults } from '../en';
const EndTimeDiv = styled.div.withConfig({
  displayName: "EditEndTime__EndTimeDiv",
  componentId: "sc-16qjsb5-0"
})(["color:", ";"], props => props.theme.palette.text.disabled);
export const EditEndTime = ({
  endTime
}) => {
  const {
    palette
  } = useTheme();
  return /*#__PURE__*/React.createElement(EndTimeDiv, {
    className: "edit-start-pickerDate-div"
  }, /*#__PURE__*/React.createElement(FormHelperText, {
    style: {
      color: palette.text.disabled
    },
    id: "component-helper-text"
  }, defaults.editEnd), /*#__PURE__*/React.createElement(ReactDateTimePicker, {
    inputMargin: "0 0 4px 0",
    inputWidth: "5.5rem",
    selectedDate: endTime,
    dateFormat: "h:mm aa",
    showTimeSelectOnly: true,
    readOnly: true // hides the date picker -- cannot change
    // disabled
    ,
    onChange: _noop,
    color: "red"
  }));
};
export default EditEndTime;